export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} data-testid="logo-mark">
    <defs>
      <linearGradient id="gentec-g" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00F0FF" />
        <stop offset="1" stopColor="#10B981" />
      </linearGradient>
    </defs>
    <path
      d="M20 3 34.5 9.8v10.4c0 8.6-5.8 13.8-13 16.1-7.2-2.3-13-7.5-13-16.1V9.8L20 3Z"
      stroke="url(#gentec-g)"
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <circle cx="20" cy="13" r="2.1" fill="#00F0FF" />
    <path
      d="M20 15.1v6.4m0 0h5.1m-5.1 0-4.3 4.7"
      stroke="url(#gentec-g)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="25.6" cy="21.5" r="1.6" fill="#34D399" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button
    onClick={onClick}
    data-testid="nav-logo"
    className="flex items-center gap-2.5 transition-opacity hover:opacity-85"
  >
    <LogoMark className="h-8 w-8" />
    <span className="font-display text-lg font-bold tracking-tight text-slate-50">
      Gentec<span className="text-cyan-300">IT</span>
    </span>
  </button>
);
